const de: Record<string, string> = {
  "Name": "Name",
  "First name": "Vorname",
  "Last name": "Nachname",
  "Username": "Benutzername",
  "Email": "E-Mail",
  "Status": "Status",
  "Active": "aktiv",
  "Inactive": "inaktiv",
  "New admin": "Admin anlegen",
  "Create admin": "Admin anlegen",
  "Edit admin": "Admin bearbeiten",
  "Delete admin": "Admin löschen",
  "Admin deleted": "Admin gelöscht.",
  "Created.": "angelegt",
  "Saved.": "gespeichert",
  "Save": "speichern",
  "Cancel": "abbrechen",
  "Delete": "löschen",
  "Edit": "bearbeiten",
  "Duplicate": "duplizieren",
  "New": "neu erzeugen",
  "Password": "Passwort",
  "Set new password": "neues Passwort setzen",
  "New password": "neues Passwort",
  "Confirm password": "Passwort bestätigen",
  "Show password": "Passwort anzeigen",
  "Hide password": "Passwort verbergen",
  "Username is required": "Benutzername ist erforderlich.",
  "Password is required": "Passwort ist erforderlich.",
  "Invalid email": "E-Mail-Adresse ist ungültig.",
  "Max. 80 characters": "höchstens 80 Zeichen",
  "Password too short (min. 4)": "Passwort muss mindestens 4 Zeichen enthalten.",
  "Passwords do not match": "Passwörter stimmen nicht überein.",
  "Platform admin cannot deactivate self": "Das eigene Admin-Konto kann nicht deaktiviert werden.",
  "Platform admin at least one must stay active": "Mindestens ein Admin muss aktiv bleiben.",
  "Do you really want to delete the admin \"{0}\"? This action cannot be undone.": "Admin „{0}“ unwiderruflich löschen?",
  "—": "—"
};

const en: Record<string, string> = {
  "Name": "Name",
  "First name": "First name",
  "Last name": "Last name",
  "Username": "Username",
  "Email": "Email",
  "Status": "Status",
  "Active": "Active",
  "Inactive": "Inactive",
  "New admin": "New admin",
  "Create admin": "Create admin",
  "Edit admin": "Edit admin",
  "Delete admin": "Delete admin",
  "Admin deleted": "Admin deleted",
  "Created.": "Created.",
  "Saved.": "Saved.",
  "Save": "Save",
  "Cancel": "Cancel",
  "Delete": "Delete",
  "Edit": "Edit",
  "Duplicate": "Duplicate",
  "New": "New",
  "Password": "Password",
  "Set new password": "Set new password",
  "New password": "New password",
  "Confirm password": "Confirm password",
  "Show password": "Show password",
  "Hide password": "Hide password",
  "Username is required": "Username is required",
  "Password is required": "Password is required",
  "Invalid email": "Invalid email",
  "Max. 80 characters": "Max. 80 characters",
  "Password too short (min. 4)": "Password too short (min. 4)",
  "Passwords do not match": "Passwords do not match",
  "Platform admin cannot deactivate self": "Platform admin cannot deactivate self",
  "Platform admin at least one must stay active": "Platform admin at least one must stay active",
  "Do you really want to delete the admin \"{0}\"? This action cannot be undone.": "Do you really want to delete the admin \"{0}\"? This action cannot be undone.",
  "—": "—"
};

const ru: Record<string, string> = {
  "Name": "Имя",
  "First name": "Имя",
  "Last name": "Фамилия",
  "Username": "Имя пользователя",
  "Email": "Эл. почта",
  "Status": "Статус",
  "Active": "активен",
  "Inactive": "неактивен",
  "New admin": "Добавить администратора",
  "Create admin": "Добавить администратора",
  "Edit admin": "Изменить администратора",
  "Delete admin": "Удалить администратора",
  "Admin deleted": "Администратор удалён.",
  "Created.": "создан",
  "Saved.": "сохранено",
  "Save": "сохранить",
  "Cancel": "отмена",
  "Delete": "удалить",
  "Edit": "изменить",
  "Duplicate": "дублировать",
  "New": "создать новый",
  "Password": "Пароль",
  "Set new password": "Новый пароль",
  "New password": "Новый пароль",
  "Confirm password": "Подтвердите пароль",
  "Show password": "Показать пароль",
  "Hide password": "Скрыть пароль",
  "Username is required": "Укажите имя пользователя.",
  "Password is required": "Укажите пароль.",
  "Invalid email": "Некорректный адрес эл. почты.",
  "Max. 80 characters": "не более 80 символов",
  "Password too short (min. 4)": "Пароль должен содержать не менее 4 символов.",
  "Passwords do not match": "Пароли не совпадают.",
  "Platform admin cannot deactivate self": "Нельзя отключить свою учётную запись администратора.",
  "Platform admin at least one must stay active": "Хотя бы один администратор должен оставаться активным.",
  "Do you really want to delete the admin \"{0}\"? This action cannot be undone.": "Удалить администратора «{0}» без возможности восстановления?",
  "—": "—"
};

const uk: Record<string, string> = {
  "Name": "Ім’я",
  "First name": "Ім’я",
  "Last name": "Прізвище",
  "Username": "Ім’я користувача",
  "Email": "Ел. пошта",
  "Status": "Статус",
  "Active": "активний",
  "Inactive": "неактивний",
  "New admin": "Додати адміністратора",
  "Create admin": "Додати адміністратора",
  "Edit admin": "Змінити адміністратора",
  "Delete admin": "Видалити адміністратора",
  "Admin deleted": "Адміністратора видалено.",
  "Created.": "створено",
  "Saved.": "збережено",
  "Save": "зберегти",
  "Cancel": "скасувати",
  "Delete": "видалити",
  "Edit": "змінити",
  "Duplicate": "дублювати",
  "New": "створити новий",
  "Password": "Пароль",
  "Set new password": "Новий пароль",
  "New password": "Новий пароль",
  "Confirm password": "Підтвердьте пароль",
  "Show password": "Показати пароль",
  "Hide password": "Приховати пароль",
  "Username is required": "Укажіть ім’я користувача.",
  "Password is required": "Укажіть пароль.",
  "Invalid email": "Некоректна адреса ел. пошти.",
  "Max. 80 characters": "не більше 80 символів",
  "Password too short (min. 4)": "Пароль має містити щонайменше 4 символи.",
  "Passwords do not match": "Паролі не збігаються.",
  "Platform admin cannot deactivate self": "Не можна вимкнути власний обліковий запис адміністратора.",
  "Platform admin at least one must stay active": "Принаймні один адміністратор має залишатися активним.",
  "Do you really want to delete the admin \"{0}\"? This action cannot be undone.": "Видалити адміністратора «{0}» без можливості відновлення?",
  "—": "—"
};

const it: Record<string, string> = {
  "Name": "Nome",
  "First name": "Nome",
  "Last name": "Cognome",
  "Username": "Nome utente",
  "Email": "E-mail",
  "Status": "Stato",
  "Active": "attivo",
  "Inactive": "inattivo",
  "New admin": "Aggiungi amministratore",
  "Create admin": "Aggiungi amministratore",
  "Edit admin": "Modifica amministratore",
  "Delete admin": "Elimina amministratore",
  "Admin deleted": "Amministratore eliminato.",
  "Created.": "creato",
  "Saved.": "salvato",
  "Save": "salva",
  "Cancel": "annulla",
  "Delete": "elimina",
  "Edit": "modifica",
  "Duplicate": "duplica",
  "New": "genera nuova",
  "Password": "Password",
  "Set new password": "Imposta nuova password",
  "New password": "Nuova password",
  "Confirm password": "Conferma password",
  "Show password": "Mostra password",
  "Hide password": "Nascondi password",
  "Username is required": "Inserisci il nome utente.",
  "Password is required": "Inserisci la password.",
  "Invalid email": "Indirizzo e-mail non valido.",
  "Max. 80 characters": "massimo 80 caratteri",
  "Password too short (min. 4)": "La password deve contenere almeno 4 caratteri.",
  "Passwords do not match": "Le password non coincidono.",
  "Platform admin cannot deactivate self": "Non puoi disattivare il tuo account amministratore.",
  "Platform admin at least one must stay active": "Almeno un amministratore deve rimanere attivo.",
  "Do you really want to delete the admin \"{0}\"? This action cannot be undone.": "Eliminare definitivamente l’amministratore «{0}»?",
  "—": "—"
};

export const adminUsersTranslations: Record<string, Record<string, string>> = { de, en, ru, uk, it };
export function adminUsersText(language: string, key: string): string {
  return (adminUsersTranslations[language] ?? en)[key] ?? key;
}
export function hasAdminUsersText(key: string): boolean {
  return Object.hasOwn(en, key);
}

const errorTranslations: Record<string, Record<string, string>> = {
  de: { title: "Admins", tenants: "Mandanten", InvalidInput: "Eingaben sind ungültig.", IdentifierConflict: "Benutzername oder E-Mail-Adresse wird bereits verwendet.", OwnAccessRequired: "Das eigene Admin-Konto kann nicht deaktiviert oder gelöscht werden.", LastActiveAdminRequired: "Mindestens ein Admin muss aktiv bleiben.", AccountInUse: "Das Konto wird bereits verwendet und kann nur deaktiviert werden.", OperationFailed: "Vorgang fehlgeschlagen." },
  en: { title: "Admins", tenants: "Tenants", InvalidInput: "Invalid input.", IdentifierConflict: "Username or email is already in use.", OwnAccessRequired: "You cannot deactivate or delete your own admin account.", LastActiveAdminRequired: "At least one admin must remain active.", AccountInUse: "The account is in use and can only be deactivated.", OperationFailed: "Operation failed." },
  ru: { title: "Администраторы", tenants: "Организации", InvalidInput: "Некорректные данные.", IdentifierConflict: "Имя пользователя или адрес эл. почты уже используется.", OwnAccessRequired: "Нельзя отключить или удалить свою учётную запись администратора.", LastActiveAdminRequired: "Хотя бы один администратор должен оставаться активным.", AccountInUse: "Учётная запись используется; её можно только отключить.", OperationFailed: "Операция не выполнена." },
  uk: { title: "Адміністратори", tenants: "Організації", InvalidInput: "Некоректні дані.", IdentifierConflict: "Ім’я користувача або адреса ел. пошти вже використовується.", OwnAccessRequired: "Не можна вимкнути або видалити власний обліковий запис адміністратора.", LastActiveAdminRequired: "Принаймні один адміністратор має залишатися активним.", AccountInUse: "Обліковий запис використовується; його можна лише вимкнути.", OperationFailed: "Операцію не виконано." },
  it: { title: "Amministratori", tenants: "Organizzazioni", InvalidInput: "Dati non validi.", IdentifierConflict: "Nome utente o e-mail già in uso.", OwnAccessRequired: "Non puoi disattivare o eliminare il tuo account amministratore.", LastActiveAdminRequired: "Almeno un amministratore deve rimanere attivo.", AccountInUse: "L’account è in uso e può essere solo disattivato.", OperationFailed: "Operazione non riuscita." },
};
const loginTranslations: Record<string, { loginIdentifier: string; loginRequired: string }> = {
  de: { loginIdentifier: "Benutzername / E-Mail", loginRequired: "Benutzername oder E-Mail-Adresse ist erforderlich." },
  en: { loginIdentifier: "Username / email", loginRequired: "Enter your username or email address." },
  ru: { loginIdentifier: "Имя пользователя / эл. почта", loginRequired: "Укажите имя пользователя или адрес эл. почты." },
  uk: { loginIdentifier: "Ім’я користувача / ел. пошта", loginRequired: "Укажіть ім’я користувача або адресу ел. пошти." },
  it: { loginIdentifier: "Nome utente / e-mail", loginRequired: "Inserisci nome utente o indirizzo e-mail." },
};
export function adminUsersDictionary(language: string): Record<string, string> {
  return Object.fromEntries(Object.entries({ ...(errorTranslations[language] ?? errorTranslations.en), ...(loginTranslations[language] ?? loginTranslations.en) }).map(([key, value]) => [`AdminUsers.${key}`, value]));
}
export function adminUsersErrorText(language: string, error: unknown): string {
  let key: unknown;
  if (error && typeof error === "object") {
    const value = error as { code?: unknown; message?: unknown; bodyText?: unknown };
    key = value.code ?? value.message;
    if (typeof value.bodyText === "string") {
      try { const body: unknown = JSON.parse(value.bodyText); if (body && typeof body === "object" && "error" in body) key = body.error; }
      catch { key = undefined; }
    }
  }
  const dictionary = adminUsersDictionary(language);
  return typeof key === "string" && Object.hasOwn(dictionary, key) ? dictionary[key] : dictionary["AdminUsers.OperationFailed"];
}
